<template>
  <div class="home">
    <div class="carousel">
      <el-carousel height="40vh" arrow="never" :autoplay="true">
        <el-carousel-item>
          <img :src="this.publicData.serverUrl + 'images/banenr.png'" alt="" />
        </el-carousel-item>
        <el-carousel-item>
          <img :src="this.publicData.serverUrl + 'images/banner0.jpg'" alt="" />
        </el-carousel-item>
        <el-carousel-item>
          <img :src="this.publicData.serverUrl + 'images/banner0.jpg'" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content">
      <div class="content-item">
        <div class="content-item-header">
          <div class="title">{{ $t('lang.external.home.作品推荐') }}</div>
          <router-link
            target="_self"
            :to="{ name: 'Architecture' }"
            class="more"
          >
            {{ $t('lang.external.home.更多作品') }}
            <i class="el-icon-d-arrow-right"></i>
          </router-link>
        </div>
        <Recommend />
      </div>
      <div class="content-item">
        <div class="content-item-header">
          <div class="title">{{ $t('lang.external.home.动态新闻') }}</div>
          <router-link
            target="_self"
            class="more"
            :to="{ path: '/introduction', query: { id: 29 } }"
          >
            {{ $t('lang.external.home.更多新闻') }}
            <i class="el-icon-d-arrow-right"></i>
          </router-link>
        </div>
        <News />
      </div>
    </div>
  </div>
</template>

<script>
import { userInfo } from '@/api/user/user'
import Recommend from '@/components/home/recommend.vue'
import News from '@/components/home/news.vue'
export default {
  name: 'Home',
  components: { Recommend, News },
  data() {
    return {}
  },
  created() {
    let token = window.localStorage.getItem('token')
    if (token) this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      userInfo().then((res) => {
        const { userInfo, school } = res.data
        this.$store.commit('SET_USETINFO', userInfo)
        this.$store.commit('SETUSERLOGIN', true)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.home {
  font-family: Microsoft YaHei;
  p {
    margin: 0 0 10px 0;
  }
  .carousel {
    img {
      width: 100%;
      height: 100%;
    }
    ::v-deep .el-carousel__indicators--horizontal {
      left: 85%;
      .el-carousel__button {
        width: 8px;
        height: 8px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
      }
      .is-active {
        .el-carousel__button {
          width: 50px;
          height: 8px;
          background: #a63528;
          box-shadow: 0px 1px 2px 0px rgba(242, 247, 250, 0.63);
          border-radius: 4px;
        }
      }
    }
  }
  .content {
    width: 100%;
    padding: 30px 18% 0 18%;
    color: #666666;
    &-item {
      width: 100%;
      margin-bottom: 50px;
      &-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .title {
          padding: 14px 20px 18px 20px;
          font-size: 20px;
          color: #ffffff;
          line-height: 18px;
          background-image: var(--homebtn-bg);
          background-size: 100% 100%;
        }
        .more {
          font-size: 16px;
          color: #0c5893;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
